import React from 'react'
import OwlCarousel from 'react-owl-carousel2'
import PropTypes from 'prop-types'
import FeaturedProductCard from './FeaturedProductCard'
import owlCarouselConfig from '../../owlCarouselConfig'
class FeaturedProductsCarousel extends React.Component {
  render () {
    const options = Object.assign({}, owlCarouselConfig, {
      responsive: {
        0: {
          items: 1
        },
        550: {
          items: 2,
          slideBy: 2,
          stagePadding: 0
        },
        768: {
          items: 1,
          slideBy: 1,
          stagePadding: 0
        },
        1200: {
          items: 1,
          slideBy: 1,
          stagePadding: 0
        },
        1500: {
          items: 1,
          slideBy: 1,
          stagePadding: 0
        },
        1600: {
          items: 1,
          slideBy: 1
        }
      }
    })

    const featuredProductCards = this.props.featuredProducts.map(
      (product, idx) => <FeaturedProductCard product={product} key={idx} />
    )

    let carousel
    if (featuredProductCards.length > 0) {
      carousel = (
        <OwlCarousel
          options={options}
          className='explore-featured-products-carousel owl-carousel owl-theme'
        >
          {featuredProductCards}
        </OwlCarousel>
      )
    }

    return (
      <React.Fragment>
        <div className='FeaturedProductsCarousel'>
          <div className='featured-products section-container mid-section'>
            <div className='plans-block'>
              <div className='container-fluid'>
                <div className='row'>{carousel}</div>
              </div>
            </div>
          </div>
        </div>
        <div className='visible-xs mobile featured-tile'>
          {featuredProductCards[0]}
        </div>
      </React.Fragment>
    )
  }
}

FeaturedProductsCarousel.propTypes = {
  featuredProducts: PropTypes.array
}

export default FeaturedProductsCarousel
